"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TermTypes;
(function (TermTypes) {
    TermTypes["TERMED"] = "TERMED";
    TermTypes["EVERGREEN"] = "EVERGREEN";
})(TermTypes = exports.TermTypes || (exports.TermTypes = {}));
var CustomerTypes;
(function (CustomerTypes) {
    CustomerTypes["B2B"] = "B&I/Corporate";
    CustomerTypes["B2C"] = "B2C";
})(CustomerTypes = exports.CustomerTypes || (exports.CustomerTypes = {}));
var PaypalPaymentGateway;
(function (PaypalPaymentGateway) {
    PaypalPaymentGateway["CIMA_PAYPAL"] = "UK - CIMA (PayPal)";
    PaypalPaymentGateway["AICPA_PAYPAL"] = "US - AICPA (PayPal)";
})(PaypalPaymentGateway = exports.PaypalPaymentGateway || (exports.PaypalPaymentGateway = {}));
exports.ZUORA_ORDER_ERROR_INVALID_FIELD = '58560020';
exports.ZUORA_ORDER_ERROR_REASON_DIRTY_INVOICE = 'This action could not be performed, because you are trying to amend a cancelled subscription.';
var SubscriptionStatus;
(function (SubscriptionStatus) {
    SubscriptionStatus["ACTIVE"] = "Active";
    SubscriptionStatus["INACTIVE"] = "Inactive";
})(SubscriptionStatus = exports.SubscriptionStatus || (exports.SubscriptionStatus = {}));
var ZuoraAccountStatus;
(function (ZuoraAccountStatus) {
    ZuoraAccountStatus["ACTIVE"] = "Active";
    ZuoraAccountStatus["CANCELED"] = "Canceled";
    ZuoraAccountStatus["PROVISIONED"] = "Provisioned";
})(ZuoraAccountStatus = exports.ZuoraAccountStatus || (exports.ZuoraAccountStatus = {}));
var ZuoraAccountInfo;
(function (ZuoraAccountInfo) {
    ZuoraAccountInfo["NO_PURCHASED"] = "NO_PURCHASED";
    ZuoraAccountInfo["NO_ACCOUNT"] = "NO_ACCOUNT";
})(ZuoraAccountInfo = exports.ZuoraAccountInfo || (exports.ZuoraAccountInfo = {}));
//# sourceMappingURL=subscription.js.map